import { InputPhoneNumber } from '@/components/input-phone-number/input-phone-number.view';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import { ChangeEvent } from 'react';
import { usePhoneQuestion } from './phone-question.controller';

interface IFormQuestionProps {
	id?: string;
	label: string;
	name?: string;
	onChange: (e: ChangeEvent<HTMLInputElement | Element>) => void;
	onBlur?: (e: ChangeEvent<HTMLInputElement | Element>) => void;
	isLoading?: boolean;
	value: string;
	error?: string;
	isInvalid?: boolean;
}

export default function PhoneQuestion(props: IFormQuestionProps) {
	const { getDefaultCountry } = usePhoneQuestion(props);

	const handlePhoneChange = (value: string) => {
		// Create a synthetic event to maintain compatibility with the existing form handling
		const syntheticEvent = {
			target: { value },
		} as ChangeEvent<HTMLInputElement>;
		props.onChange(syntheticEvent);
	};

	return (
		<FormControl isInvalid={props.isInvalid} mt={4}>
			<FormLabel>{props.label}</FormLabel>
			<InputPhoneNumber
				value={props.value}
				onChange={handlePhoneChange}
				defaultCountry={getDefaultCountry()}
			/>
			<FormErrorMessage>{props.error}</FormErrorMessage>
		</FormControl>
	);
}
